import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { cn, getStatusColor, calculatePercentage } from "@/lib/utils";
import { KPIData } from "@shared/types";

interface KPICardProps {
  kpi: KPIData;
}

export function KPICard({ kpi }: KPICardProps) {
  const percentComplete = kpi.percentComplete;
  const statusClass = getStatusColor(kpi.status);
  
  // Determine trend icon and color
  const trendIcon = kpi.trend > 0 ? "arrow-up" : "arrow-down";
  const trendColor = kpi.trend > 0 ? "text-success" : "text-error";
  
  return (
    <Card className="p-4" data-testid="kpi-card" data-metric-name={kpi.title}>
      <CardContent className="p-0">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-gray-500 dark:text-neutral-400 text-sm font-medium" data-testid="kpi-title">{kpi.title}</p>
            <p className="text-2xl font-medium mt-1" data-testid="kpi-value">{kpi.value}</p>
            <div className="flex items-center mt-1">
              <span className={`mdi mdi-${trendIcon} ${trendColor} text-lg`}></span>
              <span className={`${trendColor} text-sm ml-1`}>{kpi.trend > 0 ? '+' : ''}{kpi.trend}%</span>
              <span className="text-gray-500 dark:text-neutral-400 text-xs ml-2">vs Last Month</span>
            </div>
          </div>
          <div className={cn("w-10 h-10 rounded-full flex items-center justify-center", statusClass)}>
            <span className={`mdi mdi-${kpi.icon} text-xl`}></span>
          </div>
        </div>
        
        <div className="mt-4">
          <Progress value={percentComplete} className="h-1" />
        </div>
        
        <div className="mt-1 flex justify-between text-xs">
          <span className="text-gray-500 dark:text-neutral-400" data-testid="kpi-goal">Goal: {kpi.goal}</span>
          <span className="font-medium">{percentComplete}% Complete</span>
        </div>
      </CardContent>
    </Card>
  );
}
